import { createSlice } from "@reduxjs/toolkit";
import { backdrop } from "../../types/slices/customType";
import { RootState } from "../store";

const initialState: backdrop =
{
  showBackdrop: false,
}

const backdropSlice = createSlice({
    name: 'backdropSlice',
    initialState,
    reducers:{
        onShowBackdrop (state) {
            state.showBackdrop  = true
        },
        onHideBackdrop ( state ) {
            state.showBackdrop  = false
        },
    }
});

export const { onShowBackdrop, onHideBackdrop } = backdropSlice.actions;
export const selectAuth = (state:RootState) => state.snackbarSlice;
export default backdropSlice.reducer;